export default "__VITE_ASSET__BC61$nX8__"